/* ============================================
   MEGA MENU JS - JustForFunFlags
   Phase 2: Desktop & Mobile interactions
   UPDATED: Hover for desktop
   ============================================ */

(function() {
  'use strict';

  // ==================== CONFIGURATION ====================
  const CONFIG = {
    selectors: {
      container: '.mega-menu-container',
      nav: '.mega-menu-nav',
      navItem: '.mega-menu-nav__item',
      navLink: '.mega-menu-nav__link',
      dropdown: '.mega-menu-dropdown',
      scrollContainer: '.mega-menu-scroll',
      scrollHint: '.mega-menu-scroll-hint',
      sectionTitle: '.mega-menu-section__title',
      sectionList: '.mega-menu-section__list',
      // Mobile
      toggle: '.nav-trigger',
      mobileMenu: '.mega-menu-mobile',
      mobileLink: '.mega-menu-mobile__link',
      mobileSubmenu: '.mega-menu-mobile__submenu',
      columnHeader: '.mega-menu-mobile__column-header',
      columnSection: '.mega-menu-mobile__section',
      sectionHeader: '.mega-menu-mobile__section-header',
      sectionLinks: '.mega-menu-mobile__links'
    },
    classes: {
      active: 'is-active',
      open: 'is-open',
      expanded: 'is-expanded',
      collapsed: 'is-collapsed',
      hidden: 'is-hidden'
    },
    breakpoint: 768,
    hoverDelay: 150,      // Delay before opening on hover
    closeDelay: 300       // Delay before closing when mouse leaves
  };

  let hoverTimeout;
  let closeTimeout;

  // ==================== DESKTOP: MENU TOGGLE ====================
  function initDesktopMenu() {
    const navLinks = document.querySelectorAll(CONFIG.selectors.navLink);
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    
    navLinks.forEach(link => {
      // Direct links (no data-menu, e.g. "Banner Garden Flags") are plain
      // anchors — leave them alone so they navigate normally.
      if (!link.getAttribute('data-menu')) return;

      if (isTouchDevice) {
        // Touch devices have no hover, so the dropdown can't preview itself.
        // First tap opens the dropdown (and blocks navigation); if the
        // dropdown is already open, a second tap on the same heading lets
        // the click through so it navigates normally.
        link.addEventListener('click', function(e) {
          const menuId = this.getAttribute('data-menu');
          const dropdown = document.getElementById('mega-menu-' + menuId);
          const isOpen = dropdown && dropdown.classList.contains(CONFIG.classes.active);

          if (!isOpen) {
            e.preventDefault();
            toggleDesktopMenu(menuId, this);
          }
          // else: dropdown already open — let the click navigate through.
        });
      } else {
        // Desktop: hover to open the preview dropdown.
        link.addEventListener('mouseenter', function() {
          clearTimeout(closeTimeout);
          const menuId = this.getAttribute('data-menu');
          
          hoverTimeout = setTimeout(() => {
            openDesktopMenu(menuId, this);
          }, CONFIG.hoverDelay);
        });

        link.addEventListener('mouseleave', function() {
          clearTimeout(hoverTimeout);
        });

        // Clicking the heading navigates to its collection — the dropdown
        // is just a hover preview, so we no longer block the click here.
      }
    });

    // Handle dropdown hover
    const dropdowns = document.querySelectorAll(CONFIG.selectors.dropdown);
    dropdowns.forEach(dropdown => {
      if (!isTouchDevice) {
        dropdown.addEventListener('mouseenter', function() {
          clearTimeout(closeTimeout);
        });

        dropdown.addEventListener('mouseleave', function() {
          closeTimeout = setTimeout(() => {
            closeAllDesktopMenus();
          }, CONFIG.closeDelay);
        });
      }
    });

    // Close when clicking outside
    document.addEventListener('click', function(e) {
      const container = document.querySelector(CONFIG.selectors.container);
      if (container && !container.contains(e.target)) {
        closeAllDesktopMenus();
      }
    });

    // Close menu on escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        closeAllDesktopMenus();
      }
    });

    // Handle nav container mouse leave
    const nav = document.querySelector(CONFIG.selectors.nav);
    if (nav && !isTouchDevice) {
      nav.addEventListener('mouseleave', function() {
        closeTimeout = setTimeout(() => {
          closeAllDesktopMenus();
        }, CONFIG.closeDelay);
      });
    }
  }

  function toggleDesktopMenu(menuId, clickedLink) {
    const dropdown = document.getElementById('mega-menu-' + menuId);
    const isOpen = dropdown && dropdown.classList.contains(CONFIG.classes.active);

    // Close all menus first
    closeAllDesktopMenus();

    // If wasn't open, open it
    if (!isOpen && dropdown) {
      dropdown.classList.add(CONFIG.classes.active);
      clickedLink.classList.add(CONFIG.classes.active);
      
      // Show scroll hint if scrollable
      checkScrollHint(dropdown);
    }
  }

  function openDesktopMenu(menuId, link) {
    closeAllDesktopMenus();
    
    const dropdown = document.getElementById('mega-menu-' + menuId);
    if (dropdown) {
      dropdown.classList.add(CONFIG.classes.active);
      link.classList.add(CONFIG.classes.active);
      checkScrollHint(dropdown);
    }
  }

  function closeAllDesktopMenus() {
    const dropdowns = document.querySelectorAll(CONFIG.selectors.dropdown);
    const links = document.querySelectorAll(CONFIG.selectors.navLink);
    
    dropdowns.forEach(d => d.classList.remove(CONFIG.classes.active));
    links.forEach(l => l.classList.remove(CONFIG.classes.active));
  }

  // ==================== DESKTOP: SCROLL HINT ====================
  function checkScrollHint(dropdown) {
    const scrollContainer = dropdown.querySelector(CONFIG.selectors.scrollContainer);
    const scrollHint = dropdown.querySelector(CONFIG.selectors.scrollHint);
    
    if (scrollContainer && scrollHint) {
      // Show hint if content is scrollable
      if (scrollContainer.scrollWidth > scrollContainer.clientWidth) {
        scrollHint.classList.remove(CONFIG.classes.hidden);
        
        // Hide hint after user scrolls
        scrollContainer.addEventListener('scroll', function hideHint() {
          scrollHint.classList.add(CONFIG.classes.hidden);
          scrollContainer.removeEventListener('scroll', hideHint);
        }, { once: true });
        
        // Auto-hide after 3 seconds
        setTimeout(() => {
          scrollHint.classList.add(CONFIG.classes.hidden);
        }, 3000);
      } else {
        scrollHint.classList.add(CONFIG.classes.hidden);
      }
    }
  }

  // ==================== DESKTOP: COLLAPSIBLE SECTIONS ====================
  function initCollapsibleSections() {
    const sectionTitles = document.querySelectorAll(CONFIG.selectors.sectionTitle + '[data-toggle]');
    
    sectionTitles.forEach(title => {
      title.addEventListener('click', function() {
        const listId = this.getAttribute('data-toggle');
        const list = document.getElementById(listId);
        const arrow = this.querySelector('.arrow');
        
        if (list) {
          const isCollapsed = list.classList.contains(CONFIG.classes.collapsed);
          
          if (isCollapsed) {
            list.classList.remove(CONFIG.classes.collapsed);
            this.classList.add(CONFIG.classes.expanded);
            if (arrow) arrow.textContent = '▼';
          } else {
            list.classList.add(CONFIG.classes.collapsed);
            this.classList.remove(CONFIG.classes.expanded);
            if (arrow) arrow.textContent = '▶';
          }
        }
      });
    });
  }

  // ==================== MOBILE: HAMBURGER TOGGLE ====================
  function initMobileMenu() {
    const toggle = document.querySelector(CONFIG.selectors.toggle);
    const mobileMenu = document.querySelector(CONFIG.selectors.mobileMenu);
    
    if (toggle && mobileMenu) {
      toggle.addEventListener('click', function() {
        this.classList.toggle(CONFIG.classes.open);
        mobileMenu.classList.toggle(CONFIG.classes.open);
        
        // Prevent body scroll when menu is open
        document.body.style.overflow = mobileMenu.classList.contains(CONFIG.classes.open) ? 'hidden' : '';
      });
    }

    // Initialize accordion levels
    initMobileAccordion();
  }

  // ==================== MOBILE: ACCORDION ====================
  function initMobileAccordion() {
    // Level 1: Main categories (Garden Flags, House Flags, etc.)
    const mobileLinks = document.querySelectorAll(CONFIG.selectors.mobileLink);
    mobileLinks.forEach(link => {
      // Direct links (anchors, e.g. "Banner Garden Flags") have no submenu —
      // let them navigate instead of toggling an accordion.
      if (link.tagName === 'A') return;
      link.addEventListener('click', function(e) {
        e.preventDefault();
        toggleMobileLevel(this, CONFIG.selectors.mobileSubmenu);
      });
    });

    // Level 2: Columns (Best Sellers, Seasons, etc.)
    const columnHeaders = document.querySelectorAll(CONFIG.selectors.columnHeader);
    columnHeaders.forEach(header => {
      header.addEventListener('click', function() {
        toggleMobileLevel(this, CONFIG.selectors.columnSection);
      });
    });

    // Level 3: Sections (Spring, Summer, etc.)
    const sectionHeaders = document.querySelectorAll(CONFIG.selectors.sectionHeader);
    sectionHeaders.forEach(header => {
      header.addEventListener('click', function() {
        toggleMobileLevel(this, CONFIG.selectors.sectionLinks);
      });
    });
  }

  function toggleMobileLevel(trigger, submenuSelector) {
    const isActive = trigger.classList.contains(CONFIG.classes.active);
    const parent = trigger.parentElement;
    // Submenu is the next sibling of trigger (not parent's next sibling)
    const submenu = trigger.nextElementSibling;
    const arrow = trigger.querySelector('.arrow');

    // Close ALL sibling submenus at the same level
    const siblings = parent.parentElement.children;
    Array.from(siblings).forEach(sibling => {
      // Skip the current parent
      if (sibling === parent) return;
      
      // Find trigger in this sibling
      const siblingTrigger = sibling.querySelector('.' + trigger.className.split(' ')[0]);
      
      if (siblingTrigger && siblingTrigger !== trigger) {
        siblingTrigger.classList.remove(CONFIG.classes.active);
        const siblingArrow = siblingTrigger.querySelector('.arrow');
        if (siblingArrow) siblingArrow.textContent = '▼';
        
        // Close the submenu (next sibling of the trigger)
        const siblingSubmenu = siblingTrigger.nextElementSibling;
        if (siblingSubmenu) {
          siblingSubmenu.classList.remove(CONFIG.classes.open);
        }
      }
    });

    // Toggle current
    if (submenu) {
      if (isActive) {
        trigger.classList.remove(CONFIG.classes.active);
        submenu.classList.remove(CONFIG.classes.open);
        if (arrow) arrow.textContent = '▼';
      } else {
        trigger.classList.add(CONFIG.classes.active);
        submenu.classList.add(CONFIG.classes.open);
        if (arrow) arrow.textContent = '▲';
      }
    }
  }

  // ==================== MOBILE: CLOSE ON RESIZE ====================
  function initResizeHandler() {
    let resizeTimer;
    
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        if (window.innerWidth > CONFIG.breakpoint) {
          // Close mobile menu when resizing to desktop
          const toggle = document.querySelector(CONFIG.selectors.toggle);
          const mobileMenu = document.querySelector(CONFIG.selectors.mobileMenu);
          
          if (toggle) toggle.classList.remove(CONFIG.classes.open);
          if (mobileMenu) mobileMenu.classList.remove(CONFIG.classes.open);
          document.body.style.overflow = '';
        }
      }, 250);
    });
  }

  // ==================== ACCESSIBILITY ====================
  function initAccessibility() {
    // Add keyboard navigation for desktop menu
    const navLinks = document.querySelectorAll(CONFIG.selectors.navLink);
    
    navLinks.forEach((link, index) => {
      link.setAttribute('tabindex', '0');
      
      link.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.click();
        }
        
        // Arrow key navigation
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          const next = navLinks[index + 1] || navLinks[0];
          next.focus();
        }
        
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          const prev = navLinks[index - 1] || navLinks[navLinks.length - 1];
          prev.focus();
        }
      });
    });

    // Mobile menu keyboard support
    const toggle = document.querySelector(CONFIG.selectors.toggle);
    if (toggle) {
      // The trigger is a <span> (generic role), which can't legally carry
      // aria-expanded/aria-label. Promote it to a real button role so the
      // ARIA is valid and it's keyboard-operable (fixes Lighthouse ARIA flags).
      toggle.setAttribute('role', 'button');
      if (!toggle.hasAttribute('tabindex')) toggle.setAttribute('tabindex', '0');
      toggle.setAttribute('aria-label', 'Toggle navigation menu');
      toggle.setAttribute('aria-expanded', 'false');
      
      toggle.addEventListener('click', function() {
        const isOpen = this.classList.contains(CONFIG.classes.open);
        this.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
      // Enter / Space activate it, like a native button.
      toggle.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          this.click();
        }
      });
    }
  }

  // ==================== AUTO-EXPAND CURRENT SEASON ====================
  // Reads data-season and data-holiday from the Liquid-rendered #mega-menu-auto div
  // and expands the matching sections in both desktop and mobile menus.

  function expandDesktopSection(id) {
    const el = document.getElementById(id);
    if (!el) return;
    el.classList.remove(CONFIG.classes.collapsed);
    const header = document.querySelector('[data-toggle="' + id + '"]');
    if (header) {
      header.classList.add(CONFIG.classes.expanded);
      const arrow = header.querySelector('.arrow');
      if (arrow) arrow.textContent = '▼';
    }
  }

  function collapseDesktopSection(id) {
    const el = document.getElementById(id);
    if (!el) return;
    el.classList.add(CONFIG.classes.collapsed);
    const header = document.querySelector('[data-toggle="' + id + '"]');
    if (header) {
      header.classList.remove(CONFIG.classes.expanded);
      const arrow = header.querySelector('.arrow');
      if (arrow) arrow.textContent = '▶';
    }
  }

  function autoExpandCurrentSeason() {
    const meta = document.getElementById('mega-menu-auto');
    if (!meta) return;

    const season  = meta.dataset.season;   // e.g. 'summer'
    const holiday = meta.dataset.holiday;  // e.g. 'summer-hol' or ''

    const seasons  = ['spring', 'summer', 'fall', 'winter'];
    const holidays = ['spring-hol', 'summer-hol', 'fall-hol', 'winter-hol'];
    const prefixes = ['gf', 'hf']; // garden flags, house flags

    prefixes.forEach(prefix => {
      // Collapse all seasons, expand the current one
      seasons.forEach(s => collapseDesktopSection(prefix + '-' + s));
      expandDesktopSection(prefix + '-' + season);

      // Collapse all holidays, expand the current one if set
      holidays.forEach(h => collapseDesktopSection(prefix + '-' + h));
      if (holiday) expandDesktopSection(prefix + '-' + holiday);
    });

    // ── Mobile: auto-open the "Seasons" column for Garden & House Flags ──
    // Find all mobile section headers that contain the current season text
    // and programmatically open them so the user sees the right section expanded.
    autoExpandMobileSeason(season, holiday);
  }

  function autoExpandMobileSeason(season, holiday) {
    // Map season/holiday key → display text to match against button text
    const seasonLabels = {
      'spring'     : 'Spring',
      'summer'     : 'Summer',
      'fall'       : 'Fall',
      'winter'     : 'Winter'
    };
    const holidayLabels = {
      'spring-hol' : 'Spring Holidays',
      'summer-hol' : 'Summer Holidays',
      'fall-hol'   : 'Fall Holidays',
      'winter-hol' : 'Winter Holidays'
    };

    const targetSeason  = seasonLabels[season]  || '';
    const targetHoliday = holidayLabels[holiday] || '';

    // Find mobile section headers that match and open their link list
    const sectionHeaders = document.querySelectorAll(CONFIG.selectors.sectionHeader);
    sectionHeaders.forEach(header => {
      const text = header.textContent.trim().replace(/[▼▶▲]/g, '').trim();
      if (text === targetSeason || (targetHoliday && text === targetHoliday)) {
        const links = header.nextElementSibling;
        if (links && !links.classList.contains(CONFIG.classes.open)) {
          header.classList.add(CONFIG.classes.active);
          links.classList.add(CONFIG.classes.open);
          const arrow = header.querySelector('.arrow');
          if (arrow) arrow.textContent = '▲';
        }
      }
    });
  }

  // ==================== MEGA MENU LINK PATCHING ====================
  // Appends ?type=[handle] (and &tag=[filter-tag] when detectable) to every
  // real link inside each dropdown/mobile-item so the filter bar shows the
  // correct product-type and category context when arriving on a sub-collection.

  // Map of normalised link text → filter-bar tag value (holidays & occasions).
  var _TAG_TEXT_MAP = {
    "valentine's day":   'valentines-day',
    "st. patrick's day": 'st-patricks-day',
    'easter':            'easter',
    "mother's day":      'mothers-day',
    "father's day":      'fathers-day',
    'memorial day':      'memorial-day',
    '4th of july':       '4th-of-july',
    'halloween':         'halloween',
    'thanksgiving':      'thanksgiving',
    'christmas':         'christmas',
    'hanukkah':          'hanukkah',
    'new year':          'new-year',
    'birthday':          'birthday',
    'graduation':        'graduation',
    'wedding':           'wedding',
    'anniversary':       'anniversary',
    'baby & kids':       'baby-and-kids',
    'family':            'family',
    'memorial':          'cemetery'
  };

  function patchMegaMenuLinks() {
    var dropdowns = document.querySelectorAll('.mega-menu-dropdown[data-type]');
    for (var i = 0; i < dropdowns.length; i++) {
      _patchContainerLinks(dropdowns[i], dropdowns[i].getAttribute('data-type'));
    }
    var mobileItems = document.querySelectorAll('.mega-menu-mobile__item[data-type]');
    for (var i = 0; i < mobileItems.length; i++) {
      _patchContainerLinks(mobileItems[i], mobileItems[i].getAttribute('data-type'));
    }
  }

  function _patchContainerLinks(container, typeHandle) {
    var links = container.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      var a    = links[i];
      var href = a.getAttribute('href');
      if (!href || href === '#' || href === '/#' || href.charAt(0) === '#') continue;
      if (href.indexOf('/#') === 0) continue;
      if (href.indexOf('type=') !== -1) continue; // already patched

      var tags = _getTagsForLink(a, container);
      var sep  = href.indexOf('?') !== -1 ? '&' : '?';
      href = href + sep + 'type=' + typeHandle;
      if (tags.length) href = href + '&tag=' + tags.join(',');
      a.setAttribute('href', href);
    }
  }

  // Walk up DOM within container to find element whose className contains cls.
  function _ancestorByClass(el, cls, container) {
    while (el && el !== container) {
      if (el.className && typeof el.className === 'string' && el.className.indexOf(cls) !== -1) return el;
      el = el.parentNode;
    }
    return null;
  }

  // Return the column/section title for a link (e.g. "seasons", "holidays", "themes").
  function _colTitle(a, container) {
    var col = _ancestorByClass(a, 'mega-menu-column', container);
    if (col) {
      var t = col.querySelector('.mega-menu-column__title');
      if (t) return (t.textContent || t.innerText || '').trim().toLowerCase();
    }
    var section = _ancestorByClass(a, 'mega-menu-mobile__section', container);
    if (section) {
      var prev = section.previousElementSibling;
      if (prev && prev.className && typeof prev.className === 'string'
          && prev.className.indexOf('mega-menu-mobile__column-header') !== -1) {
        return (prev.textContent || prev.innerText || '').replace(/[▼▶▲]/g, '').trim().toLowerCase();
      }
    }
    return null;
  }

  // Strip emoji / special chars; keep a-z, 0-9, apostrophe, ampersand, space, period.
  function _normText(a) {
    var text = (a.textContent || a.innerText || '');
    return text.replace(/[^a-zA-Z0-9'\s&\.]/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  // Return ALL filter-bar tag candidates for a link, as an array.
  // A single link can carry several (e.g. "Beach" under the Summer column →
  // ['summer','beach']).  filter-bar.js validates each against its known tag
  // lists and silently drops any that aren't real filters, so it's safe to be
  // generous with candidates here.
  function _getTagsForLink(a, container) {
    var tags = [];
    function add(t) { if (t && tags.indexOf(t) === -1) tags.push(t); }

    // 1. Season — from a data-season ancestor (e.g. <ul id="gf-spring" data-season="spring">)
    var season = null;
    var el = a.parentNode;
    while (el && el !== container) {
      if (el.getAttribute && el.getAttribute('data-season')) { season = el.getAttribute('data-season'); break; }
      el = el.parentNode;
    }
    // …or a season word in the link text (simple menus: "🌸 Spring" etc.)
    var rawText = (a.textContent || a.innerText || '').toLowerCase();
    if (!season) {
      if (/\bspring\b/.test(rawText))      season = 'spring';
      else if (/\bsummer\b/.test(rawText)) season = 'summer';
      else if (/\bfall\b/.test(rawText))   season = 'fall';
      else if (/\bwinter\b/.test(rawText)) season = 'winter';
    }
    if (season) add(season);

    // 2. Holiday / Occasion text lookup
    var norm = _normText(a);
    if (_TAG_TEXT_MAP[norm]) add(_TAG_TEXT_MAP[norm]);

    // 3. Theme candidate — for links in a Theme column OR a specific item inside
    //    a Season column (e.g. Sunflowers / Beach / Tropical under Summer).
    var colTitle   = _colTitle(a, container);
    var inThemeCol = colTitle && colTitle.indexOf('theme') !== -1;
    if (inThemeCol || season) {
      var slug = norm.replace(/[^a-z0-9\s]/g, '').replace(/\s+/g, '-');
      if (slug && ['spring', 'summer', 'fall', 'winter'].indexOf(slug) === -1) add(slug);
    }

    return tags;
  }

  // ==================== INITIALIZATION ====================
  function init() {
    // Wait for DOM
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  }

  // Get all close icons
  const closeIcons = document.querySelectorAll('.close-icon-new');

  closeIcons.forEach(closeIcon => {
    closeIcon.addEventListener('click', function(event) {
      event.preventDefault();
     
      // Remove is-open class from mega-menu-mobile
      const megaMenu = document.getElementById('mega-menu-mobile');
      if (megaMenu) {
        megaMenu.classList.remove('is-open');
      }
      document.body.classList.remove('off-canvas-body');

      // Remove overflow from body
      document.body.style.overflow = '';
    });
  });

  function initAll() {
    const container = document.querySelector(CONFIG.selectors.container);
    
    if (!container) {
      console.warn('Mega Menu: Container not found');
      return;
    }

    initDesktopMenu();
    initCollapsibleSections();
    initMobileMenu();
    initResizeHandler();
    initAccessibility();
    autoExpandCurrentSeason(); // ← auto-expand season/holiday on load
    patchMegaMenuLinks();      // ← append ?type= (and &tag=) to all nav links

    console.log('Mega Menu: Initialized with hover functionality');
  }

  // Start
  init();

})();